// Default job durations (in minutes) keyed by canonical `service_type`
// strings. Kept in sync with the backend's `SERVICE_TYPE_DEFAULT_DURATIONS`
// in /app/backend/server.py — both layers must agree so the Calendar UI
// reads identical values whether the duration was derived server-side or
// (defensively) client-side.
//
// The backend's `_lead_to_calendar_event` / `_appointment_to_calendar_event`
// already resolve `event.duration_minutes` to the effective value before
// sending it to the FE. These helpers exist primarily so:
//   • the duration-edit form can pre-fill correctly even for legacy events
//     where the backend somehow returned null,
//   • the "Add to device calendar" export and the displayed text stay
//     consistent in the same single source of truth.
export const SERVICE_TYPE_DEFAULT_DURATIONS = {
  "Standard Clean": 120,
  "Deep Clean": 240,
  "Move-In": 240,
  "Move-Out": 240,
  "Airbnb Turnover": 180,
  "Office / Commercial": 180,
  "Post-Construction": 300,
};

export const DEFAULT_JOB_DURATION_MINUTES = 120;

export function getDefaultDurationMinutes(serviceType) {
  if (!serviceType || typeof serviceType !== "string") {
    return DEFAULT_JOB_DURATION_MINUTES;
  }
  const v = SERVICE_TYPE_DEFAULT_DURATIONS[serviceType.trim()];
  return typeof v === "number" ? v : DEFAULT_JOB_DURATION_MINUTES;
}

// Convenience: resolves the effective duration for an event-like object
// that may carry its own `duration_minutes` (highest priority — owner
// edits / server snapshot) but falls back to the service-type default.
export function resolveEventDurationMinutes(event) {
  if (!event) return DEFAULT_JOB_DURATION_MINUTES;
  const explicit = event.duration_minutes;
  if (typeof explicit === "number" && explicit > 0) return explicit;
  return getDefaultDurationMinutes(event.service_type);
}
